import React from 'react';

import cn from 'classnames';
import ContentLoader from 'react-content-loader';

import { Avatar } from '@shared/components';

import styles from './Nav.less';

const labelPlaceholder = (
  <ContentLoader
    width={50}
    height={16}
    style={{ width: '50px', height: '16px' }}
  >
    <rect x="0" y="0" rx="3" ry="3" width="50" height="16" />
  </ContentLoader>
);

interface NavMenuItemContentProps {
  icon: React.ReactElement;
  children: React.ReactNode;
  loading?: boolean;
  showLabels: boolean;
  containerClassNames?: string;
}

const NavMenuItemContent: React.FC<NavMenuItemContentProps> = ({
  icon,
  children,
  loading,
  showLabels,
  containerClassNames,
}) => {
  const styledIcon = React.cloneElement(icon, {
    className: cn(styles.icon, icon.props.className),
  });

  const labelClassName = cn(styles.label, {
    [styles.hiddenLabels]: !showLabels,
  });

  return (
    <div className={cn(styles.itemContentContainer, containerClassNames)}>
      <Avatar
        className={styles.iconContainer}
        placeholder={styledIcon}
        loading={loading}
      />
      <span className={labelClassName}>
        {loading ? labelPlaceholder : children}
      </span>
    </div>
  );
};

export default NavMenuItemContent;
